var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Button',{staticClass:"btn-color10",attrs:{"loading":_vm.loader},on:{"click":_vm.requestURL}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }